export default __webpack_public_path__ + "static/media/Phone.7f39162c.svg";